VLW.HomePIXI = class extends VLW.classBase {
	constructor(o) {
		super();
		this.uid                = guid();
		this.containerMain      = new PIXI.Container();
		this.containerMain.name = "HomePixiMainContainer";
		this.outroLaunched      = false;
		this.loaded 			= false;
		this.options 			= o;
		this.homeDisplacement   = new VLW.HomePIXIDisplacement();
	}
	
	set displacementType(type) {
		this.homeDisplacement.displacementType = type;
	}
	
	set align(align) {
		this.homeDisplacement.align = align;
	}
	
	set resources(resources) {
		let oAdjustmentFilter      = {
			gamma     : 0.9,
			saturation: 0,
			contrast  : 0.1,
			brightness: 1.2,
			red       : 1.6,
			green     : 1.5,
			blue      : 1.3,
			alpha     : 1,
		};
		let oOldFilmFilterMenuOn                   = {
			sepia          : 0.7,
			noise          : 0,
			noiseSize      : 0,
			scratch        : 0,
			scratchDensity : 0,
			scratchWidth   : 0,
			vignetting     : .3,
			vignettingAlpha: 1,
			vignettingBlur : .5,
		};
		this.loaded 							   = true;
		this.homeDisplacement.resources            = resources;
		this.renderTextureHomeDisplacement         = PIXI.RenderTexture.create(getDocSize().width, getDocSize().height);
		this.spriteHomeDisplacement                = this.constructor.createSprite(this.renderTextureHomeDisplacement);
		this.spriteHomeDisplacementMenu            = this.constructor.createSprite(this.renderTextureHomeDisplacement);
		this.spriteHomeDisplacementMenu.renderable = false;
		this.spriteHomeDisplacement.name           = "spriteHomeDisplacement";
		this.spriteHomeDisplacementMenu.name       = "spriteHomeDisplacementMenu";
		// this.spriteHomeDisplacementMenu.filters    = [new PIXI.filters.OldFilmFilter(oOldFilmFilterMenuOn)];
		this.spriteHomeDisplacementMenu.filters    = [new PIXI.filters.AdjustmentFilter(oAdjustmentFilter)];
		this.spriteHomeDisplacementMenu.scale.set(1.05);
		this.containerMain.addChild(this.spriteHomeDisplacementMenu, this.spriteHomeDisplacement);
		PIXIAPP.addChild(this.containerMain);
		this.renderable = true;
		this.size();
		if(this.doIntroWhenLoaded===true){
			this.intro();
		}
	}
	
	resize() {
		this.size();
	}
	
	size() {
		let _scaleDelta = 1;
		this.renderTextureHomeDisplacement.resize(windowSize.width * _scaleDelta, windowSize.height * _scaleDelta);
		this.spriteHomeDisplacement 	&& this.spriteHomeDisplacement.position.set(windowSize.width * _scaleDelta * .5, windowSize.height * _scaleDelta * .5);
		this.spriteHomeDisplacementMenu && this.spriteHomeDisplacementMenu.position.set(windowSize.width * _scaleDelta * .5, windowSize.height * _scaleDelta * .5);
		this.homeDisplacement.size();
	}
	
	onCompleteOutro() {
		this.renderable = false;
		PIXIAPP.app.stage.removeChild(this.containerMain);
		this.instanceClean();
	}
	
	instanceClean() {
		if (this.renderable === false) {
			try {
				PIXIAPP.app.stage.removeChild(this.containerMain);
				this.spriteHomeDisplacementMenu.filters = null;
				this.containerMain.destroy({children: true, texture: true, baseTexture: true});
				this.renderTextureHomeDisplacement.destroy();
				this.homeDisplacement.instanceClean();
				
			}catch (e) {
			
			}
			super.instanceClean();
		}
	}
	
	onMenuHover() {
		return;
		if (!this.spriteHomeDisplacement) {
			return;
		}
		TweenMax.killTweensOf(this.spriteHomeDisplacement);
		this.spriteHomeDisplacementMenu.renderable = true;
		TweenMax.to(this.spriteHomeDisplacement, .75, {pixi: {alpha: 0, ease: Sine.easeOut}});
	}
	
	onMenuLeave() {
		if (!this.spriteHomeDisplacement || window.site.isLoading) {
			return;
		}
		TweenMax.to(this.spriteHomeDisplacement, 1.75, {
			pixi   : {alpha: 1, scale: 1.05}, onComplete: () => {
				this.spriteHomeDisplacementMenu && (this.spriteHomeDisplacementMenu.renderable = false);
			}, ease: Sine.easeOut
		});
	}
	
	introFirst() {
		this.tlIntro = new TimelineMax();
		this.tlIntro.fromTo(this.spriteHomeDisplacement, 1.25, {pixi: {scale: 1}}, {pixi: {scale: 1}, delay: .4, ease: Sine.easeOut});
		this.tlIntro.fromTo(this.spriteHomeDisplacement, 1.5, {pixi: {alpha: 0}}, {pixi: {alpha: 1}, delay: .2, ease: Power2.easeIn}, 0);
		this.onCompleteIntro();
	}
	
	outro() {
		this.tlIntro && this.tlIntro.pause();
		this.outroLaunched         = true;
		let oAdjustmentFilter      = {
			gamma     : 1,
			saturation: 0,
			contrast  : 1,
			brightness: .5,
			red       : 1.6,
			green     : 0.7,
			blue      : 0.4,
			alpha     : 0,
		};
		
		oAdjustmentFilter      = {
			gamma     : 1.25,
			saturation: 0,
			contrast  : 1,
			brightness: 1.5,
			red       : 1,
			green     : 1,
			blue      : 1,
			alpha     : 1,
		};
		let _filter                = new PIXI.filters.AdjustmentFilter();
		let _filterblur            = new PIXI.filters.BlurFilter(2);
		_filterblur.blur           = 0;
		this.containerMain.filters = [_filter, _filterblur];
		let _scale                 = 1.0;
		let tl                     = new TimelineMax({onComplete: this.onCompleteOutro});
		tl.addLabel("dezoom");
		tl.to(this.containerMain, 3, {pixi: {scale: _scale, x: getDocSize().width * ((1 - _scale) * .5), y: getDocSize().height * ((1 - _scale) * .5)}, ease: Power2.easeInOut}, "dezoom");
		tl.to(_filterblur		, 1.5, {blur: 5}, "dezoom");
		tl.to(this.containerMain, 1.5, {alpha: 0}, "dezoom+=1.5");
		TweenMax.to(_filter, 2, oAdjustmentFilter);
		broadCaster.MENU_HOVER.remove(this.onMenuHover);
		broadCaster.MENU_LEAVE.remove(this.onMenuLeave);
		broadCaster.BACKGROUND_HIDE.remove(this.onMenuHover);
		broadCaster.BACKGROUND_SHOW.remove(this.onMenuLeave);
	}
	
	intro(delay = 0) {
		if(!this.loaded) {
			this.doIntroWhenLoaded = true;
			return;
		}
		PIXIAPP.aToRender.push(this);
		broadCaster.PAGE_INTRO_CONTENT.dispatch();
		let oAdjustmentFilterFrom  = {
			gamma     : 1,
			saturation: 0,
			contrast  : 1,
			brightness: .5,
			red       : 1.6,
			green     : 0.7,
			blue      : 0.4,
			alpha     : 1,
		};
		oAdjustmentFilterFrom      = {
			gamma     : 0.9,
			saturation: 0,
			contrast  : 0.1,
			brightness: 1.2,
			red       : 1.6,
			green     : 1.5,
			blue      : 1.3,
			alpha     : 1,
		};
		let oAdjustmentFilterTo    = {
			gamma     : 1,
			saturation: 1,
			contrast  : 1,
			brightness: 1,
			red       : 1,
			green     : 1,
			blue      : 1,
			alpha     : 1,
		};
		let _filter                = new PIXI.filters.AdjustmentFilter(oAdjustmentFilterFrom);
		this.containerMain.filters = [_filter];
		this.tlIntro               = new TimelineMax({delay:0});
		this.tlIntro.to(_filter, 2, {...oAdjustmentFilterTo, ease: Power2.easeInOut, onComplete: () => {this.containerMain && (this.containerMain.filters = null);}}, .5);
		this.tlIntro.fromTo(this.spriteHomeDisplacement, 3, {pixi: {scale: 1.0}}, {pixi: {scale: 1.05}, ease: Sine.easeInOut}, .75);
		this.tlIntro.fromTo(this.spriteHomeDisplacement, 1, {pixi: {alpha: 0}}, {pixi: {alpha: 1}, ease: Sine.easeIn}, 0);
		this.tlIntro.call(this.onCompleteIntro, [], this, 2);
	}
	
	onCompleteIntro() {
		if (!this.onMenuHover || this.outroLaunched) {
			return;
		}
		broadCaster.MENU_HOVER.add(this.onMenuHover);
		broadCaster.MENU_LEAVE.add(this.onMenuLeave);
		broadCaster.BACKGROUND_HIDE.add(this.onMenuHover);
		broadCaster.BACKGROUND_SHOW.add(this.onMenuLeave);
	}
	
	render() {
		if (this.renderable === false) {
			return;
		}
		this.homeDisplacement.render();
		PIXIAPP.app.renderer.render(this.homeDisplacement.mainContainer, this.renderTextureHomeDisplacement);
	}
	
	static createSprite(texture = null) {
		let sprite = new PIXI.Sprite(texture);
		sprite.anchor.set(.5);
		return sprite;
	}
}